import React, { useContext } from 'react';
import { AppContext } from 'src/components/app-context';
import type { PrismicSlicePopularProducts } from 'src/types';
import { ProductsSection } from 'src/components/products-section';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

const PopularProducts = ({ popularFacet }: PrismicSlicePopularProducts) => {
  const { t } = useContext(AppContext);

  if (!popularFacet?.products?.length) {
    return null;
  }

  const { title, url, linkText, products } = popularFacet;

  return (
    <ProductsSection
      products={products}
      title={title}
      linkTitle={linkText ?? t('common', 'button.show-more')}
      linkPath={url}
      onHeaderLinkClick={() =>
        trackInternalNavigationClick({
          scope: InternalNavigationScope.POPULAR_PRODUCTS_HEADER,
          nextPage: url,
        })
      }
      onProductCardClick={data => {
        trackInternalNavigationClick({
          scope: InternalNavigationScope.POPULAR_PRODUCTS_PRODUCT_CARD,
          nextPage: data.link,
          index: data.index,
        });
      }}
    />
  );
};

export default PopularProducts;
